import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React, { useEffect, useRef } from 'react';
import useLatest from 'use-latest';

var castArray = function castArray(value) {
  return Array.isArray(value) ? value : [value];
};

var useOuterClick = function useOuterClick(refs, handler) {
  if (handler === void 0) {
    handler = function handler() {};
  }

  if (process.env.NODE_ENV !== 'production' && typeof handler !== 'function') {
    throw new TypeError("Expected \"handler\" to be a function, not " + typeof handler + ".");
  }

  var refsRef = useLatest(refs);
  var handerRef = useLatest(handler);
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (castArray(refsRef.current).every(function (ref) {
        return ref.current && ref.current !== event.target && !ref.current.contains(event.target);
      })) {
        handerRef.current(event);
      }
    };

    document.addEventListener('mousedown', handleClickOutside, true);
    document.addEventListener('touchstart', handleClickOutside, true);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside, true);
      document.removeEventListener('touchstart', handleClickOutside, true);
    };
  }, []);
};

var OuterClick = function OuterClick(props) {
  var Element = props.as,
      children = props.children,
      onOuterClick = props.onOuterClick,
      restProps = _objectWithoutPropertiesLoose(props, ["as", "children", "onOuterClick"]);

  var ref = useRef();
  useOuterClick(ref, onOuterClick);
  return /*#__PURE__*/React.createElement(Element, _extends({}, restProps, {
    ref: ref
  }), children);
};

OuterClick.defaultProps = {
  as: 'div',
  children: null
};
export { OuterClick, useOuterClick };